<!-- eslint-disable vue/no-confusing-v-for-v-if -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <main :class="[`wl--${env('WHITE_LABEL_NAME')}`]" class="main">
    <div class="login__wrapper col-12">
      <div :class="[{'error': error || passwordRequestFailed}]" class="login__container">
        <img v-if="!isNil(season)" ref="logo" :src="!isNil(season) ? seasonalLogo : logo" class="login__logo">
        <img v-else ref="logo" :src="logo" class="login__logo">
        <h1 v-if="!isEmpty(season)">{{ $t(`login.season.${season}`) }}</h1>
        <h1 v-else-if="env('WHITE_LABEL_KEY') !== 'allinone'">{{ $t('login.my_hotelsoftware',[env('WHITE_LABEL_NAME') || 'Hotelmeister']) }}</h1>
        <h1 v-else>{{ env('WHITE_LABEL_NAME') || 'Hotelmeister' }}</h1>
        <span v-if="systemStatus !== 'ok'"><small class="color--warn"><i class="fal fa-exclamation-triangle"></i> {{ $t('pageLogin.systemStatus.warn') }}</small></span>
        <span v-if="beta" style="color: red;text-align:center;">Bitte verwenden Sie die Beta-Version nur, so lange wie Sie von unserem Support-Team dazu angewiesen wurden. Andernfalls wechseln Sie bitte auf die <a href="#" @click="goToLive">Live-Version</a><br><br>Die dauerhafte Verwendung der Beta-Version kann zu schwerwiegenden Schäden, bis hin zum Datenverlusten führen!</span>
        <span v-if="error" class="login__error">{{ $t('login.failed') }}</span>
        <span v-if="passwordRequested" class="login__error">{{ $t('login.password_requested') }}</span>
        <span v-if="passwordRequestFailed" class="login__error">{{ $t('login.password_request_failed') }}</span>
        <form @submit="login">
          <hm-col :grid="true" cols="1">
            <hm-input-select v-if="instanceSelect"
                             :validate="'required'"
                             v-model="subdomain"
                             :lazy="true"
                             :label="$t('login.subdomain')"
                             :parent-errors="errors"
                             name="subdomain"
                             cols="12"
                             autocomplete="subdomain">
              <option v-for="instance in instances" :value="instance" v-html="instance"></option>
              <template slot="icon-inline-right">
                <input-icon-button v-tooltip="{ title: $t('login.differentInstance'), delay: 250, placement: 'top', positionFixed: true, trigger: 'hover', touch: false }" :border="true" icon="plus" @click="instanceSelect = false" />
              </template>
            </hm-input-select>
            <hm-input v-else
                      :validate="'required'"
                      v-model="subdomain"
                      :lazy="true"
                      :label="$t('login.subdomain')"
                      :parent-errors="errors"
                      name="subdomain"
                      cols="12"
                      autocomplete="subdomain" />
            <hm-input :validate="'required|regex:^[^\.\\\s\@]+(\@[a-zA-Z0-9\\-]+)?$'"
                      v-model="username"
                      :lazy="true"
                      :label="$t('login.username')"
                      :parent-errors="errors"
                      name="username"
                      cols="12"
                      autocomplete="username" />
            <hm-input :validate="'required|min_length:4'"
                      v-model="password"
                      :lazy="true"
                      :label="$t('login.password')"
                      :parent-errors="errors"
                      name="password"
                      cols="12"
                      type="password"
                      autocomplete="current-password" />
            <hm-input v-if="beta"
                      v-model="betaAccessCode"
                      :lazy="true"
                      :label="$t('login.betaAccessCode')"
                      name="betaAccessCode"
                      cols="12"
                      type="password"
                      autocomplete="beta-access-code" />
            <hm-button :disabled="!canResetPassword" class="btn--password" cols="6" @click="requestPassword">{{ $t('login.forgot_password') }}</hm-button>
            <hm-button class="btn--login" cols="6" @click="login">{{ $t('login.login') }}</hm-button>
            <input type="submit" class="hidden" @click="login">
            <hm-col cols="12" class="security-notice__wrapper">
              <p class="security-notice">{{ $t('login.securityNotice') }}</p>
            </hm-col>
            <hm-col cols="12" class="clear-cache__wrapper">
              <span class="clear-cache" @click="clearLocalStorage">{{ $t('login.clearCache') }}</span>
            </hm-col>
            <hm-col :grid="false" cols="12" class="locale__wrapper">
              <span :class="{ 'active': $locale === 'de-AT' }" class="locale" @click="setLocale('de-AT')">de-at</span> |
              <span :class="{ 'active': $locale === 'de-CH' }" class="locale" @click="setLocale('de-CH')">de-ch</span> |
              <span :class="{ 'active': $locale === 'de' }" class="locale" @click="setLocale('de')">de</span> |
              <span :class="{ 'active': $locale === 'en-GB' }" class="locale" @click="setLocale('en-GB')">en</span> |
              <span :class="{ 'active': $locale === 'en-US' || $locale === 'en' }" class="locale" @click="setLocale('en-US')">en-us</span> |
              <span :class="{ 'active': $locale === 'es' }" class="locale" @click="setLocale('es')">es</span> |
              <span :class="{ 'active': $locale === 'es-US' }" class="locale" @click="setLocale('es-US')">es-us</span> |
              <span :class="{ 'active': $locale === 'el' }" class="locale" @click="setLocale('el')">el</span> |
              <span :class="{ 'active': $locale === 'fr' }" class="locale" @click="setLocale('fr')">fr</span> |
              <span :class="{ 'active': $locale === 'tr' }" class="locale" @click="setLocale('tr')">tr</span>
            </hm-col>
          </hm-col>
        </form>
        <span class="version__wrapper" @click="onClickVersion" @dblclick="showDebugInformation"><small class="version">{{ version }}</small><small v-if="versionValid === false" class="login__error"> ({{ $t('login.versionOutdated') }})</small></span>
      </div>
    </div>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import LocaleMixin from '@/mixins/LocaleMixin';
import StatusMixin from '@/mixins/StatusMixin';
import TimerMixin from '@/mixins/TimerMixin';
import {
  isArray,
  join,
  isNil,
  isEmpty,
  get,
  filter,
  last,
  find,
  nth,
  template,
  clone,
  cloneDeep,
  isEqual,
  isObject,
  debounce,
  lowerCase,
  sum
} from 'lodash';
import HmCol from '../lib/layout/HmCol';
import HmTable from '../lib/table/HmTable';
import { util } from 'protobufjs/minimal';
import HmCardInner from '../lib/layout/HmCardInner';
import ServiceUrls from '@/lib/ServiceUrls';
import HmInputSelect from '../lib/inputs/HmInputSelect';
import Redactyl from 'redactyl.js';
import ValidateMixin from '../../mixins/ValidateMixin';
import { required, requiredIf, helpers } from 'vuelidate/lib/validators';

export default {
  name: 'PageLogin',
  components: { HmInputSelect },
  mixins: [LocaleMixin, StatusMixin, TimerMixin, ValidateMixin],
  data() {
    return {
      // eslint-disable-next-line
      logo: require(`@/assets/img/svg/${(this.env('WHITE_LABEL_KEY') || 'hotelmeister')}-logo.svg`),
      // eslint-disable-next-line
      hotkeyBinding: {
        enter: this.login,
      },
      subdomain: null,
      username: null,
      password: null,
      error: false,
      passwordRequested: false,
      passwordRequestFailed: false,
      beta: false,
      instances: [],
      instanceSelect: false,
      betaAccessCode: null,
      versionValid: null,
    };
  },

  head: {
    title: function () {
      return {
        inner: this.env('WHITE_LABEL_NAME') || 'Hotelmeister',
      };
    },
  },

  validations: function() {
    return {
      username: {
        required,
        custom: helpers.withParams(
          { message: this.$t('ValidationError.invalid', { field: this.$t('login.username') }) },
          (username) => {
            if (isEmpty(username)) return false; // required is already handled, but still checking
            if (!username.includes('@')) return true; // just a plain username - looks good
            let split = username.split('@'); // if it contains an @ we need to check whether @ refers to an instance or if the user entered an email address
            if (split.length !== 2) return false; // if it contains more than one @ it's invalid
            if (isEmpty(split[0]) || isEmpty(split[1])) return false; // if either part (left or right of the @) is empty it's invalid
            if (split[1].includes('.')) return false; // this means the user likely entered an email address
            return true; // if it's not an email address it's valid
          },
        ),
        label: helpers.withParams(
          { label: this.$t('login.username') },
          () => true,
        )
      },
      subdomain: {
        required,
        label: helpers.withParams(
          { label: this.$t('login.subdomain') },
          () => true,
        )
      }
    }
  },

  computed: {
    seasonalLogo() {
      if (this.env('WHITE_LABEL_KEY') !== 'hotelmeister') return this.logo;
      if (isEmpty(this.season)) return this.logo;

      try {
        const images = require.context('@/assets/img/png/', false, /\.png$/);
        return images(`./hotelmeister-logo-${this.season}.png`);
        // return require(`@/assets/img/png/hotelmeister-${this.season}-logo.png`);
      } catch (error) {
        return this.logo;
      }
    },
    season() {
      if (this.whiteLabel !== 'hotelmeister') return null;

      if (this.inDateRange('01-01', '01-03')) return 'newyear';
      if (this.inDateRange('12-22', '12-26')) return 'christmas';
      if (this.inDateRange('02-26', '02-26')) return 'birthday';
      if (this.inDateRange('07-01', '08-31')) return 'summer';
      if (this.inDateRange('12-15', '12-31')) return 'winter';
      if (this.inDateRange('01-01', '03-15')) return 'winter';
      if (this.inDateRange('03-16', '05-15')) return 'spring';
      if (this.inDateRange('10-01', '10-31')) return 'autumn';

      return null;
    },
    whiteLabel() {
      return this.env('WHITE_LABEL_KEY') || 'hotelmeister';
    },
    canLogin() {
      return !isEmpty(this.subdomain) && !isEmpty(this.username) && !isEmpty(this.password);
    },
    canResetPassword() {
      return !isEmpty(this.subdomain) && !isEmpty(this.username);
    },
    version() {
      return `Version: ${(this.env('VERSION') || '-').split('-')[0]}`;
    },
  },

  watch: {
  },

  mounted: function () {
    document.documentElement.style.fontSize = '10px';
    this.$emit('updateHead');
  },

  created() {
    this.beta = window.location.hostname.startsWith('beta.');
    this.checkUiVersion();
    this.updateInstances();
    if (!isNil(this.$route.query) && !isEmpty(this.$route.query.instance)) {
      this.instanceSelect = false;
      this.subdomain = this.$route.query.instance;
    }
  },

  methods: {
    isNil,
    isEmpty,
    inDateRange(start, end) {
      const now = new Date().getTime();
      const year = new Date().getFullYear();
      const endOfChristmasSeason = new Date(`${year}-${end}T23:59:59`).getTime();
      const startOfChristmasSeason = new Date(`${year}-${start}T00:00:00`).getTime();
      return now >= startOfChristmasSeason && now <= endOfChristmasSeason;
    },
    updateInstances: function () {
      let instances = localStorage.getItem(`instances_${this.env('HOTELMEISTER_ENV')}`);

      // required for backwards compatibility - to avoid all customers asking for their instance name
      if (isEmpty(instances)) {
        instances = localStorage.getItem('instances');
      }

      if (isEmpty(instances)) {
        this.instances = [];
        this.instanceSelect = false;
      } else {
        this.instances = instances.split(',').sort();
        this.instanceSelect = true;
      }

      if (this.instances.length === 1) {
        this.subdomain = this.instances[0];
      }
    },
    storeInstance(instance) {
      let instances = localStorage.getItem(`instances_${this.env('HOTELMEISTER_ENV')}`);
      if (isEmpty(instances)) {
        instances = instance;
      } else if (!instances.split(',').includes(instance)) {
        instances = `${instances},${instance}`;
      }
      localStorage.setItem(`instances_${this.env('HOTELMEISTER_ENV')}`, instances);
    },
    goToLive: function () {
      window.location = window.location.origin.replace('beta.', 'app.');
    },
    env: function (name) {
      return process.env[name];
    },
    checkUiVersion: function () {
      this.axios.get(ServiceUrls.uiVersion(this))
        .then((response) => {
          this.versionValid = true;
        })
        .catch((error) => {
          if (isEmpty(error.response)) {
            this.setTimeout(this.checkUiVersion, 15000);
          } else {
            this.versionValid = false;
          }
        });
    },
    requestPassword: function ($event) {
      this.error = false;
      this.passwordRequested = false;
      this.passwordRequestFailed = false;

      if (isEmpty(this.subdomain) || isEmpty(this.username)) {
        this.passwordRequestFailed = true;
      } else {
        this.axios.post(ServiceUrls.resetPassword(this), {
          subdomain: this.subdomain,
          username: this.username,
          whiteLabel: isEmpty(window.whiteLabel) ? null : window.whiteLabel,
        })
          .then((response) => {
            this.passwordRequested = true;
          })
          .catch((error) => {
            this.passwordRequested = true;
          });
      }
    },
    clearLocalStorage: function () {
      window.clearLocalStorage();
      this.updateInstances();
      this.subdomain = null;
      this.username = null;
      this.password = null;
    },
    login: function ($event) {
      if (!isNil($event)) $event.preventDefault();

      try {
        this.$v.$touch();
      } catch(e) { /* ignore */ }

      if (!this.canLogin) return;

      if (this.beta && this.betaAccessCode !== '1234') {
        // eslint-disable-next-line no-alert
        alert('Bitte geben sie den Zugriffscode für die Beta-Version ein oder wechseln Sie auf die Live-Version.');
        return;
      }

      this.error = false;
      this.passwordRequested = false;
      this.passwordRequestFailed = false;

      this.$store.dispatch('hotel/login', {
        subdomain: this.subdomain,
        username: this.username,
        password: this.password,
        whiteLabel: isEmpty(window.whiteLabel) ? null : window.whiteLabel,
      })
        .then((userResponse) => {
          this.storeInstance(this.subdomain);
          const hotelId = this.$store.getters['hotel/hotelId'];

          const toRemove = [];
          for (let i = 0; i < localStorage.length; i++) {
            if (localStorage.key(i).includes('__hotelSettings') && !localStorage.key(i).includes(`${hotelId}__hotelSettings`)) {
              toRemove.push(localStorage.key(i));
            }
          }
          toRemove.forEach(it => localStorage.removeItem(it));

          // this.$root.hotel = this.$store.getters['hotel/hotelId'];
          // this.$root.username = this.$store.getters['hotel/username'];
          // this.$root.user = this.$store.getters['hotel/user'];

          const user = userResponse.data.data;

          this.$rollbar.configure({
            payload: {
              person: {
                id: user.id,
                username: `${user.name}@${user.tenantSubdomain}`,
                email: user.email,
              },
            },
          });

          try {
            CobrowseIO.customData = {
              user_id: user.id,
              user_name: `${user.name}@${user.tenantSubdomain}`,
              user_email: user.email,
              device_name: `${user.name}@${user.tenantSubdomain}`
            };
          } catch (ex) { /* ignore */ }

          this.$root.updateHotels();
          this.$router.push({ name: 'home', params: { hotelId: hotelId } });
        })
        .catch((error) => {
          if (!isNil(error.response) && !isNil(error.response.config) && !isNil(error.response.config.data)) {
            try {
              let data = JSON.parse(error.response.config.data);

              const redactly = new Redactyl({
                properties: [
                  'pw',
                  'pass',
                  'passwd',
                  'password',
                  'password_confirmation',
                  'passwordConfirmation',
                  'confirm_password',
                  'confirmPassword',
                  'secret',
                  'secret_token',
                  'secretToken',
                  'secret_key',
                  'secretKey',
                  'api_key',
                  'access_token',
                  'accessToken',
                  'authenticity_token',
                  'oauth_token',
                  'token',
                  'user_session_secret',
                  'request.session.csrf',
                  'request.session._csrf',
                  'request.params._csrf',
                  'request.cookie',
                  'request.cookies'],
              });
              data = redactly.redact(data);
              error.response.config.data = JSON.stringify(data);
            } catch (e) {
              error.response.config.data = null;
            }
          }
          this.$root.reportError(error);
          this.error = true;
          this.password = null;
        });
    },
    onClickVersion() {
      // eslint-disable-next-line no-undef
      updateServiceWorker();
    },
    showDebugInformation() {
      const debugInformation = `
      Version: ${this.version}
      Date/Time: ${new Date().toISOString()}
      Navigator-Online: ${navigator.onLine}
      HM-Offline: ${window.hmOffline}
      ========================================
      User-Agent: ${navigator.userAgent}
      Platform: ${navigator.platform}
      `;

      this.$rollbar.captureEvent('manual', {
        category: 'UI',
        action: 'Debug Information',
        metadata: {
          debug: debugInformation,
        },
      }, 'info');

      this.$rollbar.warn('Debug Information');

      // show a dialog with debug information, where the information can be easily copied to the clipboard
      // trim all lines of the debug information, before showing it
      // eslint-disable-next-line no-alert
      alert(debugInformation.split('\n').map(it => it.trim()).join('\n'));
    }
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';

  .clear-cache {
    text-decoration: underline;
    text-decoration-style:dashed;
    cursor:pointer;
    color: $gray;
    transition: 0.3s ease all;

    &:hover {
      text-decoration-style: solid;
      color: $text;
    }

    &__wrapper {
      padding-top:2.5rem;
      text-align:center;
      font-size:1.2rem;
    }
  }

  .security-notice {
    margin: 0;
    padding: 1rem 1.2rem;
    border: solid 1px $mint;
    border-radius: 5px;
    color: $text;
    font-size: 1.2rem;
    line-height: 1.5;
    text-align: center;

    &__wrapper {
      padding-top: 2.5rem;
    }
  }

  .download-support {
    text-decoration: underline;
    text-decoration-style:dashed;
    cursor:pointer;
    color: $gray;
    transition: 0.3s ease all;
    display: none;

    &:hover {
      text-decoration-style: solid;
      color: $text;
    }

    &__wrapper {
      padding-top:1.5rem;
      text-align:center;
      font-size:1.2rem;
    }
  }

  .wl {
    &--Hotelmeister {
      .download-support {
        display: block;
      }
    }
  }

  .locale {
    text-decoration: underline;
    text-decoration-style:dashed;
    cursor:pointer;
    color: $gray;
    transition: 0.3s ease all;

    &:hover {
      text-decoration-style: solid;
      color: $text;
    }

    &.active {
      font-weight: bold;
      text-decoration: none;
      color: $text;
    }

    &__wrapper {
      padding-top:1.5rem;
      text-align:center;
      font-size:1.2rem;
    }
  }

  .main {
    min-height: 100vh;
    min-height: 100dvh;
    align-items: center;
    grid-template-rows: minmax(100%, max-content);

    &:before {
      content: '';
      display: none;
    }
  }

  .login {
    &__error {
      color: $error;
      font-size: 1.2rem;
    }

    &__wrapper {
      display: grid;
      grid-template-columns: auto minmax(min-content, 33.6rem) auto;
      grid-template-rows: auto;
      grid-template-areas: "spacer_left login spacer_right";
    }

    &__input__wrapper {
      padding: 2rem;
      display: grid;
      grid-template-columns:  1fr;
      grid-auto-rows: max-content;
      justify-items: center;
      border: solid 1px $mint;
      border-radius: 5px;
    }

    form {
      width: 100%;
    }

    &__logo {
      width: 21.4rem;
      object-fit: contain;
    }

    &__container {
      grid-area: login;
      padding: 2.5rem;
      border-radius: 5px;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
      background-color: $white;
      display: grid;
      grid-template-columns:  1fr;
      grid-auto-rows: max-content;
      justify-items: center;
      // grid-row-gap: 2.5rem;
      grid-row-gap: 1rem;
      position: relative;

      img {
        padding: 2.5rem;
      }

      &.error {
        animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
        perspective: 1000px;
      }

      h1 {
        font-size: 18px;
        color: $black;
      }
    }
  }

  @keyframes shake {
    10%, 90% {
      transform: translate3d(-1px, 0, 0);
    }

    20%, 80% {
      transform: translate3d(2px, 0, 0);
    }

    30%, 50%, 70% {
      transform: translate3d(-4px, 0, 0);
    }

    40%, 60% {
      transform: translate3d(4px, 0, 0);
    }
  }

  .fireworks__container {
    top:0;
    left:0;
    position:fixed;
    background:#000;
    z-index:999;
    opacity:0.9;
    width:100%;
    height:100%;
  }

  .version {
    color: $middlegray;

    &__wrapper {
      position: absolute;
      top: 3px;
      right: 5px;
    }
  }
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/PageLogin.vue